export default [
  {
    userId: 1,
    name: "Daniel Treviño",
    email: "daniel.trevino@blogonline.com",
    password: "12345"
  },
  {
    userId: 2,
    name: "John Doe",
    email: "test@blogonline.com",
    password: "12345"
  }
];



// WEBPACK FOOTER //
// ./src/data/users.js